<template>
  <transition name="modal" appear>
    <!-- popup (s) -->
    <div id="messagePop" class="popWrap nowOpen">
      <span class="blind focusSet first" tabindex="0"></span>
      <div class="popup">
        <div class="popContain">
          <div class="popCont alert hasBtn" tabindex="-1" role="dialog">
            <div class="popBody">
              <div class="popInner">
                <!-- 본문 (s) -->
                <div class="msg">
                  <slot />
                </div>
                <!-- 본문 (e) -->
              </div>
            </div>

            <div class="btnArea sticky">
              <slot name="bottomButtom">
                <button type="button" class="btn_p" @click="$emit('close')">
                  확인
                </button>
              </slot>
            </div>

            <slot name="closeButton">
              <button type="button" class="btnIco_close" @click="$emit('close')">
                <span>팝업 닫기</span>
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <!-- popup (e) -->
  </transition>
</template>
<script>
export default {
  name: 'MessagePop',
};
</script>

<style lang="stylus" scoped>
@import './css/popup.styl';
</style>
